import Loading from "../Loading";
import css from "./index.module.css";
import LockIcon from '@mui/icons-material/Lock';
import CheckIcon from '@mui/icons-material/Check';
import AddBoxIcon from '@mui/icons-material/AddBox';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import PriorityHighIcon from '@mui/icons-material/PriorityHigh';

import { useState } from "react";
import { handleAvatar } from "../../utils/avatar";

/**
 * list of teammembers /challengepartners. a partner is required to start a challenge. to select a challengepartner his/hers challengecode must be entered. 
 * only the challengepartner knows is own challenge code, since it is only visible in its settings.
 * @param {*} studentId 64 character uuid of given student
 * @param {Array} studentsInClass list of students in the same class of the given student
 * @param {String} selectedTeamMember 64 character uuid of a student that was selected as teammember
 * * @param {Array} completedPrerequisites list of missions that were already completed by given student
 * @param {Function} setSelectedTeamMember set the new selected teammember
 * @returns 
 */
const Team = ({studentId, studentsInClass, completedPrerequisites, selectedTeamMember, setSelectedTeamMember}) => {
  const [open, setOpen] = useState(null);
  const possibleTeamMembers = [];
  studentsInClass?.forEach(element => {
    if(completedPrerequisites.find(p => p.student_id === element.id)){
      possibleTeamMembers.push(element)
    }
  });
  const string = `Verfügbare Challengepartner:innen (${possibleTeamMembers.length - 1}/${studentsInClass?.length})`


  if(studentsInClass == null) {
    return <Loading />;
  } else if (studentsInClass != null && studentsInClass.length === 0) {
    return <span>data not loaded</span>;
  } else if (studentsInClass != null && studentsInClass.length > 0) {
    return (
      <div className={css.list}>
        <div className={css.header}>
          <span>{string}</span>
        </div>
        <div className={css.body}>
        {possibleTeamMembers?.filter(e => e.id !== studentId).map(element => {
          return (
            <TeamListElement key={element.id} data={element} open={open} setOpen={setOpen} studentsInClass={studentsInClass} selectedTeamMember={selectedTeamMember} setSelectedTeamMember={setSelectedTeamMember}/>
          )
        })}
        </div>
      </div>
    )
  }
}

/**
 * single student list entry
 * @param {Object} data student data
 * @param {String} open uuid of a student
 * @param {Function} setOpen sets open to this students id
 * @param {Array} studentsInClass list of students in the same class of the given student
 */
const TeamListElement = ({data, open, setOpen, studentsInClass, selectedTeamMember, setSelectedTeamMember}) => {

  const [error, setError] = useState(false);

  const handleTeammember = async (event) => {
    event.preventDefault();
    const formData = new FormData(event.target);

    const teamMember = studentsInClass.find(e => e.challenge_code === formData.get("challengecode") && e.id === data.id);
    if(teamMember === undefined) {
      setError(true);
    } else {
      setSelectedTeamMember(teamMember.id)
      setError(false);
    }
  }

  const checkTeamMembers = (id) => {
    if (selectedTeamMember === null || selectedTeamMember === undefined) {
      return <AddBoxIcon onClick={() => {setOpen(data.id); setSelectedTeamMember(null); setError(false)}}/>
    } else if (selectedTeamMember === id) {
      return <CheckIcon style={{fill:'#F9B11F', stroke:'#F9B11F', FontSize:'20px'}}/>;
    } else {
      return <LockIcon />
    }
  }

  return (
    <div className={css.item}>
      <div className={css.info}>
      <div className={css.avatar}>
        {handleAvatar(data?.use_avatar, data?.avatar, data?.name)}
      </div>
      <span>{data.name}</span>
      </div>
      {
        open === data.id ? (
          <form onSubmit={handleTeammember}> 
            <input 
              type="text" 
              placeholder="Challangecode"
              name="challengecode"
              onChange={() => setError(false)}
            />
            {error && <PriorityHighIcon style={{fill:'red', FontSize:'20px'}}/>}
            <input
              type="hidden"
              value={data.id}
            />
            <button type="submit">
            {selectedTeamMember ? <CheckIcon style={{fill:'#F9B11F', stroke:'#F9B11F', FontSize:'20px'}}/> : <ArrowForwardIcon />}
            </button>
          </form>  
        ) : ( 
          checkTeamMembers(data.id)
        )}
    </div>
  )
}

export default Team;